/**
 * Safe analytics wrapper around the PostHog snippet loaded in index.html.
 * Never throws if PostHog isn't available (e.g. blocked by an ad-blocker).
 */
export function track(event, props = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch (e) {
    /* no-op */
  }
}
